// UX-043 — the one answer to "should this aggregator screen show its body?".
// Returns the element to render INSTEAD of the page body, or null when the
// caller is on an aggregator's team and the page may render normally.
//
// The membership check itself (`hasAggregatorAccess`) is AggregatorContext's and
// is unchanged. This only keeps the three situations honest:
//   loading            → a skeleton, never a premature "you're not a member"
//   request failed     → the failure (403 vs other), never "you're not a member"
//   loaded, no teams   → "You're not part of an aggregator" with a link home

import type { ReactNode } from 'react'
import { useAggregator } from '../contexts/AggregatorContext'
import AdminGate from '../components/organisation/AdminGate'
import NotAnAggregatorGate from '../components/aggregator/NotAnAggregatorGate'
import LoadingSkeleton from '../components/shared/LoadingSkeleton'

export function useAggregatorAccessGate(area: string): ReactNode | null {
  const { hasAggregatorAccess, loading, error } = useAggregator()
  if (hasAggregatorAccess) return null
  if (loading) return <LoadingSkeleton rows={4} type="list" />
  if (error) return <AdminGate area={area} error={error} />
  return <NotAnAggregatorGate area={area} />
}
